import React from 'react';
// import logo from './logo.svg';
import './App.css';

import ListPage from './pages/list-page/list-page.jsx';

function App() {
  return (
    <div className="App">
      <ListPage />
    </div>
  );
}

export default App;
